(async () => {
  const { default: Swiper, Autoplay, Navigation, Pagination } = await import('swiper');

  Swiper.use([Autoplay, Navigation, Pagination]);

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      document.body.classList.add('announcement-bar-visible');
      this.swiperElement = this.querySelector('[data-swiper-announcement-bar]');
      this.swiperOptions = this.swiperElement.dataset.options
        ? JSON.parse(this.swiperElement.dataset.options)
        : {
            autoplay: true,
            navigation: true,
            slidesPerView: 1,
            observer: true,
            threshold: 10,
            direction: 'vertical',
          };
      this.init();
    }
    init() {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

      // stop autoplay after it loops all slides and gets back to the 1st slide
      this.swiperInstance.on('reachBeginning', () => {
        this.swiperInstance.autoplay.stop();
      });

      if (Shopify.designMode && this.swiperInstance) {
        window.addEventListener('shopify:section:load', () => {
          this.swiperInstance.update();
        });

        window.addEventListener('shopify:block:select', (event) => {
          this.swiperInstance.update();
          this.handleThemeEditorEvents(event);
        });
      }
    }

    /**
     * Handles the theme editor block change/edit event
     * @param {Object} event
     */
    handleThemeEditorEvents(event) {
      // Slide to slide based on the data attribute from the target and add 1 to get the slide index
      this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
    }
  }

  window.AnnouncementBar = AnnouncementBar;

  customElements.define('announcement-bar', AnnouncementBar);
})();
